import { render, staticRenderFns } from "./PowerTranslateRight.vue?vue&type=template&id=5f5b9ee2&scoped=true"
import script from "./PowerTranslateRight.vue?vue&type=script&lang=js"
export * from "./PowerTranslateRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b9ee2",
  null
  
)

export default component.exports